<template>
    <v-container
        fluid
        class="px-4"
        v-if="staff"
        :style="{
            paddingBottom: '80px'
        }">
        <v-row>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.name')} ${$t('required')}`"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="staff.name"
                    :placeholder="$t('placeholder.nameAndLastName')"/>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.phone')} ${$t('required')}`"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="staff.phone"
                    :placeholder="$t('placeholder.contactNumber')"/>
            </v-col>

            <v-col cols="12" class="pb-0">
                <v-card-actions class="pa-0">
                    <div
                        :style="{
                            width: '250px'
                        }"
                        class="subtitle-1 font-weight-bold"
                        v-html="$t('staffList.details.user')"/>
                    <hr class="full-width ma-4">
                </v-card-actions>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.username')} ${$t('required')}`"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="staff.username"
                    :disabled="!createMode"
                    :placeholder="$t('placeholder.username')"/>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.password')} ${$t('required')}`"/>
                <password-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="staff.password"
                    :placeholder="$t('placeholder.password')"/>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.confirmPassword')} ${$t('required')}`"/>
                <password-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="staff.confirmPassword"
                    :placeholder="$t('placeholder.confirmPassword')"/>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('staffList.details.type')} ${$t('required')}`"/>

                <v-btn-toggle
                    mandatory
                    active-class="stafftype--active"
                    class="staff-type-button-group"
                    v-model="staffType">
                    <v-btn
                        block
                        height="40px">
                        {{ staffTypeMapDict[0].text }}
                    </v-btn>
                    <v-btn
                        block
                        height="40px">
                        {{ staffTypeMapDict[1].text }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>

            <v-col cols="12" v-if="!createMode">
                <v-card-actions class="pa-0">
                    <div
                        :style="{
                            width: '140px'
                        }"
                        class="subtitle-1 pb-2 font-weight-bold"
                        v-html="$t('eventList.eventDetails.details')"/>
                    <hr class="full-width ma-4">
                </v-card-actions>
                <div v-html="`<b>Latest Updatee</b>: ${$util.getDDMMYYYYDateFormat(staff.lastUpdateDate)} &ensp; &ensp; by: <b>${staff.updatedBy}</b>`"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else />
</template>

<script>
import PasswordField from '@/components/fields/PasswordField'

export default {
    name: 'StaffDetailsView',

    components: {
        PasswordField
    },

    props: {
        staff: {
            type: Object,
            default: null
        },

        createMode: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            staffTypeMapDict: {
                0: {
                    text: 'Staff',
                    value: 'Staff'
                },
                1: {
                    text: 'Administrator',
                    value: 'Administrator'
                }
            }
        }
    },

    computed: {
        staffType: {
            get () {
                const matchIndex = Object.keys(this.staffTypeMapDict).find(key => this.staffTypeMapDict[key]?.value === this.staff.role)
                return matchIndex ? parseInt(matchIndex) : null
            },

            set (value) {
                this.staff.role = this.staffTypeMapDict?.[value]?.value
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.staff-type-button-group {
    width: 50%;
}

.stafftype--active {
    background-color: #08979C !important;
    color: white !important;
}
</style>
